<template>
    <div class="p-3">
        <el-card header="Pedidos de levantamento de afiliados">

            <el-row class="py-2">
                <h5 class="v-col-6 v-col-md-9 me-3">Estado do pedido</h5>
                <div class="v-col-6 v-col-md-3">
                    <el-radio-group v-model="status">
                        <el-radio value="all" border>Todos</el-radio>
                        <el-radio value="sent" border>Pagos</el-radio>
                        <el-radio value="pending" border>Pendentes</el-radio>
                    </el-radio-group>
                </div>
            </el-row>

            <PaginatedTable :loading="loading" :page="data.current_page" :show-rows="10" :pages="data.last_page" :data="data.data" :cols="[
            ]" @change="changePage">
                <el-table-column label="Afiliado" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.affiliate.user.name }}
                    </template>
                </el-table-column>
                <el-table-column label="Valor" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ data.row.value.toFixed(2)}}MT
                    </template>
                </el-table-column>
                <el-table-column label="Data e hora" class-name="auto" :min-width="150">
                    <template #default="data">
                        {{ new Date(data.row.created_at).toLocaleString() }}
                    </template>
                </el-table-column>
                <el-table-column label="Estado" class-name="auto text-center" :min-width="150">
                    <template #default="data">
                        <span style="border-radius: 10px;" class="pa-2 px-4 text-light" :class="{'bg-success': data.row.sent, 'bg-danger': !data.row.sent}">
                            {{ data.row.sent ? 'Enviado':'Pendente' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column label="Acções" class-name="auto" :min-width="150">
                    <template #default="data">
                        <span class="p-2">
                            <el-button type="primary" @click="openWithdraw(data.row)" icon="View" title="Ver mais"></el-button>
                        </span>
                    </template>
                </el-table-column>
            </PaginatedTable>
        </el-card>

        <ModalComponent v-if="withdraw" @close="() => {withdraw = null}" cardclass="col-12 col-md-6 col-lg-5 col-x-lg-4" header="Informações do pedido">
            <WithdrawView :withdraw="withdraw" @update="(w) => {
                (withdraw as Withdraw).sent = w.sent; 
                (withdraw as Withdraw).transaction_id = w.transaction_id
            }" />
        </ModalComponent>
    </div>
</template>

<script lang="ts" setup>
    import Api from '@/services/api'
    import { h, onBeforeMount, watch } from 'vue'
    import { ref } from 'vue';
    import { ElBadge, ElButton, ElMessageBox, ElRow } from 'element-plus';
    import PaginatedTable from '@/components/PaginatedTable.vue';
    import { Paginated } from '@/services/types/paginated';
    import { defaultPaginated } from '@/utilities/helpers';
    import { Withdraw } from '@/services/types/affiliate';
    import ModalComponent from '@/components/modals/ModalComponent.vue';
    import WithdrawView from '@/components/modals/views/WithdrawView.vue';

    const loading = ref<boolean>(true)
    const data = ref<Paginated<Withdraw>>(defaultPaginated)
    const status = ref<'sent' | 'pending' | 'all'>('pending')
    const withdraw = ref<Withdraw | null>(null)
    const page = ref<number>(1)

    const getWithdraws = async () => {
        console.log("Okay")
        loading.value = true
        console.log(status.value)
        const res = await Api.get(`admin/affiliates/withdraws/getAll?page=${page.value}&status=${status.value}`)
        if (res.status == 200) {
            data.value = res.data.withdraws
            console.log(res.data.withdraws)
        } else {
            ElMessageBox.alert('Ocorreu um erro ao buscar os dados')
            console.log(res)
        }
        loading.value = false
    }

    const changePage = (p: number) => {
        page.value = p
        getWithdraws()
    }

    const openWithdraw = (row: any) => {
        // okay
        withdraw.value = row
    }

    onBeforeMount(() => {
        getWithdraws()

        document.title = "Levantamentos"
    })

    watch(status, () => {
        page.value = 1
        getWithdraws()
    })
</script>

<style lang="scss">
    .auto {
        min-width: 100px;
        width: auto !important;
        &>* {
            min-width: 100px;
            width: auto !important;
        }
    }
</style>
